<template>
  <div class="section-white">
    <div class="detail-info" v-loading="loading">
      <h3 class="title">订单详情</h3>
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3>门店信息</h3>
        </div>
        <div>
          <el-table :data="distributor_arr" style="width: 100%">
            <el-table-column prop="number" label="门店编号">
            </el-table-column>
            <el-table-column prop="name" label="门店名称">
            </el-table-column>
            <el-table-column prop="address" label="门店地址">
              <template slot-scope="scope">
                <span>{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="门店联系方式">
              <template slot-scope="scope">
                <div>{{scope.row.mobile}}</div>
                <div v-if="scope.row.telephone != '' ">座机：{{scope.row.telephone}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3>订单基本信息</h3>
        </div>
        <el-row>
          <el-col :span="3" class="content-right"><h4>订单号：</h4></el-col>
          <el-col :span="5"> {{orderInfo.order_id}} </el-col>
          <el-col :span="3" class="content-right"><h4>订单类型：</h4></el-col>
          <el-col :span="5">
            <span v-if="orderInfo.order_type=='normal'"> 实体订单 </span>
            <span v-if="orderInfo.order_type=='service'"> 服务类订单 </span>
            <span v-if="orderInfo.order_type=='bargain'"> 助力订单 </span>
          </el-col>

          <el-col :span="3" class="content-right"><h4>订单状态：</h4></el-col>
          <el-col :span="5">
            <span v-if="orderInfo.order_class=='drug'">
              <el-tag v-if="orderInfo.order_status == 'CANCEL'" type="danger" size="mini">已取消</el-tag>
              <template v-if="orderInfo.order_status != 'CANCEL'">
                <!-- 发货状态 -->
                <el-tag v-if="orderInfo.ziti_status == 'APPROVE'" type="success" size="mini">审核通过</el-tag>
                <el-tag v-else type="primary" size="mini">待审核</el-tag>
              </template>
            </span>
            <span v-else-if="orderInfo.order_type =='bargain'">
              <el-tag v-if="orderInfo.order_status == 'NOTPAY'" type="primary" size="mini">未支付</el-tag>
              <el-tag v-else-if="orderInfo.order_status == 'PAYED'" type="success" size="mini">已支付</el-tag>
            </span>
            <el-tag v-else>{{orderInfo.order_status_msg}}</el-tag>
          </el-col>

          <el-col :span="3" class="content-right"><h4>第三方来源：</h4></el-col>
          <el-col :span="5"> {{orderInfo.source}} </el-col>

          <el-col :span="3" class="content-right"><h4>文章名称：</h4></el-col>
          <el-col :span="5"> {{orderInfo.docname}} </el-col>
        </el-row>
        <el-row v-if="memberInfo">
          <el-col :span="3" class="content-right"><h4>会员姓名：</h4></el-col>
          <el-col :span="5"> {{memberInfo.username}}</el-col>
          <el-col :span="3" class="content-right"><h4>会员手机：</h4></el-col>
          <el-col :span="5"> {{memberInfo.mobile}} </el-col>
          <el-col :span="3" class="content-right"><h4>会员等级：</h4></el-col>
          <el-col :span="5">{{memberInfo.gradeInfo ? memberInfo.gradeInfo.grade_name : "无"}}</el-col>
        </el-row>
        <el-row >
          <el-col :span="3" class="content-right"><h4>商品金额：</h4></el-col>
          <el-col :span="5">{{orderInfo.fee_symbol}}{{orderInfo.order_type != 'bargain'? orderInfo.item_fee/100 : orderInfo.item_price/100}}<span class="frm-tips">(商品会员扣后价)</span></el-col>
          <el-col :span="3" class="content-right"><h4>会员折扣：</h4></el-col>
          <el-col :span="5">- {{orderInfo.fee_symbol}}{{orderInfo.member_discount/100}}</el-col>
          <el-col :span="3" class="content-right"><h4>货币：</h4></el-col>
          <el-col :span="5">{{orderInfo.fee_type}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="content-right"><h4>运费：</h4></el-col>
          <el-col :span="5">{{orderInfo.fee_symbol}}{{orderInfo.freight_fee/100}}</el-col>
          <el-col :span="3" class="content-right"><h4>优惠券减免：</h4></el-col>
          <el-col :span="5">- {{orderInfo.fee_symbol}}{{orderInfo.coupon_discount/100}}</el-col>
          <el-col :span="3" class="content-right"><h4>货币汇率：</h4></el-col>
          <el-col :span="5">{{orderInfo.fee_rate}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="content-right"><h4>优惠总金额：</h4></el-col>
          <el-col :span="5">-{{orderInfo.fee_symbol}}{{orderInfo.discount_fee ? orderInfo.discount_fee/100 : 0}}<span class="frm-tips">(包含优惠券，满折，满减等优惠金额)</span></el-col>
          <el-col :span="3" class="content-right"><h4>商家优惠券减免：</h4></el-col>
          <el-col :span="5">- {{orderInfo.fee_symbol}}{{orderInfo.merchant_coupon_discount/100}}</el-col>
          <el-col :span="3" class="content-right"><h4>下单时间：</h4></el-col>
          <el-col :span="5">{{orderInfo.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="content-right" v-if="tradeInfo.payType !='point'"><h4>订单总金额：</h4></el-col>
          <el-col :span="3" class="content-right" v-else><h4>订单总积分：</h4></el-col>
          <el-col :span="tradeInfo.payType !='point' ? 13 : 5" v-if="tradeInfo.payType !='point'">{{orderInfo.fee_symbol}}{{orderInfo.total_fee/100}}</el-col>
          <el-col :span="5" v-else>{{orderInfo.point}}</el-col>
          <el-col :span="3" class="content-right" v-if="orderInfo.delivery_time != null"><h4>下账时间：</h4></el-col>
          <el-col :span="5" v-if="orderInfo.delivery_time != null">{{orderInfo.delivery_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
        </el-row>
        <el-row v-if="orderInfo.order_type == 'service'">
          <el-col :span="3" class="content-right" v-if="orderInfo.store_name"><h4>店铺名称：</h4></el-col>
          <el-col :span="5">{{orderInfo.store_name}}</el-col>
          <el-col :span="3" class="content-right"><h4>订单来源：</h4></el-col>
          <el-col :span="5">
            <span v-if="orderInfo.order_source =='member'">自主下单</span>
            <span v-else-if="orderInfo.order_source =='shop'">代客下单</span>
          </el-col>
          <div v-if="orderInfo.order_type == 'service' && orderInfo.operator_desc !=''">
            <el-col :span="3" class="content-right"><h4>操作员：</h4></el-col>
            <el-col :span="5"> {{orderInfo.operator_desc}} </el-col>
          </div>
        </el-row>
        <el-row v-if="orderInfo.remark">
          <el-col :span="3" class="content-right"><h4>订单备注：</h4></el-col>
          <el-col :span="12">{{orderInfo.remark}}</el-col>
        </el-row>

        <el-row v-if="cancelData && orderInfo.order_status == 'CANCEL' && orderInfo.cancel_status == 'NO_APPLY_CANCEL'">
          <el-col :span="3" class="content-right"><h4>取消原因：</h4></el-col>
          <el-col :span="12">未支付自动取消</el-col>
        </el-row>
        <el-row v-if="cancelData && orderInfo.order_status == 'CANCEL' && orderInfo.cancel_status == 'SUCCESS'">
          <el-col :span="3" class="content-right"><h4>取消原因：</h4></el-col>
          <el-col :span="12">卖家申请退款</el-col>
        </el-row>
        <el-row v-if="cancelData && cancelData.cancel_from == 'buyer' && cancelData.cancel_reason">
          <el-col :span="3" class="content-right"><h4>申请取消原因：</h4></el-col>
          <el-col :span="12">{{cancelData.cancel_reason}} <span class="sp_time">|</span> 取消时间：{{cancelData.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>

        </el-row>
        <el-row v-if="cancelData && cancelData.cancel_from == 'shop' && cancelData.cancel_reason">
          <el-col :span="3" class="content-right"><h4>商家取消原因：</h4></el-col>
          <el-col :span="12">{{cancelData.cancel_reason}} <span class="sp_time">|</span> 取消时间：{{cancelData.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>

        </el-row>
      </el-card>
      <el-card shadow="never" v-if="orderInfo.discount_info && orderInfo.discount_info.length > 0">
        <div slot="header" class="clearfix">
          <h3>优惠明细</h3>
        </div>
        <el-row v-for="(item, index) in orderInfo.discount_info" :key="index"  v-if="item.type != 'full_gift'">
          <el-col :span="3" class="content-right">
            <h4>{{item.type === 'full_discount' ? '满折优惠：' : ''}}</h4>
            <h4>{{item.type === 'full_minus' ? '满减优惠：' : ''}}</h4>
            <h4>{{item.type === 'coupon_discount' ? '优惠券优惠：' : ''}}</h4>
          </el-col>
          <el-col :span="20" v-if="item.discount_fee > 0">
            {{item.merchant_iscost == 0 ? '平台' : '商家'}}
            优惠{{orderInfo.fee_symbol}}{{item.discount_fee/100}} &nbsp;&nbsp;
            <span class="frm-tips">{{item.title}}({{item.rule}})</span>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3>支付信息</h3>
        </div>
        <div class="section-body">
          <el-table :data="tradeIf" style="width: 100%">
            <el-table-column class="content-right" label="交易单号" >
              <template slot-scope="scope">
                <span>{{scope.row.tradeId}}</span>
              </template>
            </el-table-column>
            <el-table-column class="content-right" label="支付状态">
              <template slot-scope="scope">
                <span v-if="scope.row.tradeState =='SUCCESS'"> 支付成功</span>
                <span v-else-if="scope.row.tradeState =='REFUND'">转入退款</span>
                <span v-else-if="scope.row.tradeState =='CANCEL_CLOSED'">已取消</span>
                <span v-else-if="scope.row.tradeState =='REFUND_SUCCESS'">退款成功</span>
                <span v-else-if="scope.row.tradeState =='NOTPAY'">未支付</span>
                <span v-if="scope.row.tradeState =='CLOSED'"> 已关闭</span>
                <span v-else-if="scope.row.tradeState =='REVOKED'">已撤销</span>
                <span v-else-if="scope.row.tradeState =='PAYERROR'">支付失败(其他原因，如银行返回失败)</span>
              </template>
            </el-table-column>
            <el-table-column class="content-right" label="交易流水号" >
              <template slot-scope="scope">
                <span>{{scope.row.transactionId}}</span>
              </template>
            </el-table-column>
            <template v-if="tradeIf.payType !='point'">
              <el-table-column class="content-right" label="支付金额(RMB)">
                <template slot-scope="scope">
                  <span>{{scope.row.payFee/100}}</span>
                </template>
              </el-table-column>
            </template>
            <template v-if="tradeIf.payType =='point'">
              <el-table-column class="content-right" label="支付积分">
                <template slot-scope="scope">
                  <span>{{scope.row.payFee}}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column class="content-right" label="支付类型">
              <template slot-scope="scope">
                <span v-if="scope.row.payType =='amorepay'"> 微信支付</span>
                <span v-if="scope.row.payType =='wxpaypc'"> 微信PC支付</span>
                <span v-if="scope.row.payType =='wxpay'"> 微信支付</span>
                <span v-if="scope.row.payType =='wxpayapp'"> 微信APP支付</span>
                <span v-if="scope.row.payType =='wxpayh5'"> 微信H5支付</span>
                <span v-if="scope.row.payType =='alipay'"> 支付宝支付</span>
                <span v-if="scope.row.payType =='alipayapp'"> 支付宝APP支付</span>
                <span v-if="scope.row.payType =='alipayh5'"> 支付宝H5支付</span>
                <span v-else-if="scope.row.payType =='alipayxapp'"> 支付宝小程序支付</span>
                <span v-else-if="scope.row.payType =='deposit'"> 余额支付</span>
                <span v-else-if="scope.row.payType =='yaoking_deposit'"> 商城预存款</span>
                <span v-else-if="scope.row.payType =='point'"> 积分支付</span>
                <span v-else-if="scope.row.payType =='pos'"> POS银行卡支付</span>
                <span v-else-if="scope.row.payType =='yibaopay'"> 省医保支付</span>
                <span v-else-if="scope.row.payType =='jh_digital'"> 交行数字快捷支付</span>
                <span v-else-if="scope.row.payType =='spdb_h5_xppay'"> 浦发小浦支付</span>
                <span v-else-if="scope.row.payType =='ccb_h5_digital'"> 建行数字货币支付</span>
                <span v-else-if="scope.row.payType =='SCAN_ALIPAY'"> 商家支付宝支付</span>
                <span v-else-if="scope.row.payType =='WECHATPAY_MINIPROGRAM'"> 商家微信小程序支付</span>
                <span v-else-if="scope.row.payType =='peihepay'"> 沛合直付</span>
                <span v-else-if="scope.row.payType =='benefit'"> 优卡支付</span>
                <span v-else-if="scope.row.payType =='fuioupay_miniprogram'"> 富友微信小程序支付</span>
              </template>
            </el-table-column>
            <el-table-column class="content-right" label="交易时间">
              <template slot-scope="scope">
                <span>{{scope.row.timeStart | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-table-column>
            <el-table-column  class="content-right" label="交易结束时间">
              <template slot-scope="scope" v-if="scope.row.timeExpire!=null">
                <span>{{scope.row.timeExpire | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-table-column>
            <el-table-column class="content-right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.tradeState == 'NOTPAY' && (scope.row.payType == 'WECHATPAY_MINIPROGRAM' || scope.row.payType == 'SCAN_ALIPAY')" @click="getPayStatus(scope.row.tradeId)">查询交易状态</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3>商品清单</h3>
        </div>
        <div v-if="orderInfo.order_type == 'service' || orderInfo.order_type == 'bargain'">
          <el-row>
            <el-col :span="3" class="content-right">商品名称：</el-col>
            <el-col :span="5">{{orderInfo.title}}</el-col>
            <el-col :span="3" class="content-right">商品数量：</el-col>
            <el-col :span="5">{{orderInfo.item_num}}</el-col>
          </el-row>
        </div>
        <div v-else-if="orderInfo.order_type == 'normal'">
          <el-table :data="orderInfo.items" style="width: 100%">
            <el-table-column class="goods-img" prop="pic" label="商品图片" width="120">
              <template slot-scope="scope">
                <span><img class="item-image" :src="wximageurl + scope.row.pic" :alt="scope.row.item_name" /></span>
              </template>
            </el-table-column>
            <el-table-column prop="item_name" label="商品名称" width="180">
              <template slot-scope="scope">
                {{scope.row.item_name}}<el-tag size="mini" type="success" v-if="scope.row.order_item_type == 'gift'">赠品</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="item_spec_desc" label="货号" width="180">
              <template slot-scope="scope">
                {{scope.row.item_bn}}
              </template>
            </el-table-column>
            <el-table-column prop="item_spec_desc" label="规格">
              <template slot-scope="scope">
                {{scope.row.item_spec_desc ? scope.row.item_spec_desc : '单规格'}}
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" width="180"> </el-table-column>
            <el-table-column  label="总价(元)">
              <template slot-scope="scope">
                <span>{{scope.row.fee_symbol}}{{scope.row.total_fee / 100}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="货币">
              <template slot-scope="scope">
                <span>{{scope.row.fee_type}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="货币汇率">
              <template slot-scope="scope">
                <span>{{scope.row.fee_rate}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="服务费">
              <template slot-scope="scope">
                <span>{{scope.row.is_settle_in_service_price}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="总服务费">
              <template slot-scope="scope">
                <span>{{scope.row.is_settle_in_service_total_price}}</span>
              </template>
            </el-table-column>
            <template v-if="orderInfo.delivery_status == 'DONE' && !orderInfo.delivery_corp">
              <el-table-column  label="发货状态">
                <template slot-scope="scope">
                  <span>已发货</span>
                </template>
              </el-table-column>
              <el-table-column  label="快递公司">
                <template slot-scope="scope">
                  <span v-if="orderInfo.order_status == 'WAIT_BUYER_CONFIRM'">
                    <el-select v-model="scope.row.delivery_corp" filterable placeholder="请选择快递公司，可搜索">
                      <el-option
                        v-for="item in dlycorps"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                  <span v-else>{{scope.row.delivery_corp_name}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="快递单号">
                <template slot-scope="scope">
                  <span v-if="orderInfo.order_status == 'WAIT_BUYER_CONFIRM'">
                    <el-input v-model="scope.row.delivery_code" :maxlength=20 placeholder="物流公司单号"></el-input>
                  </span>
                  <span v-else>{{scope.row.delivery_code}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </el-card>
      <el-card shadow="never" v-if="orderInfo.order_class == 'drug'">
        <div slot="header" class="clearfix">
          <h3>用药人信息</h3>
        </div>
        <el-row>
          <el-col :span="3" class="content-right"><h4>用药人身份证：</h4></el-col>
          <el-col :span="5">{{orderInfo.third_params.drug_buyer_id_card ? orderInfo.third_params.drug_buyer_id_card : '未填写身份证信息'}}</el-col>
          <div v-if="orderInfo.ziti_status != 'APPROVE' && orderInfo.order_status != 'CANCEL' " >
            <el-col :span="3" class="content-right"><h4>审核处理：</h4></el-col>
            <el-col :span="10">
              <el-radio v-model="form.status" label="true">审核通过</el-radio>
              <el-radio v-model="form.status" label="false">审核拒绝</el-radio>
            </el-col>
          </div>
        </el-row>
        <el-row>
          <el-col :span="3" class="content-right"><h4>用药人姓名：</h4></el-col>
          <el-col :span="5">{{orderInfo.third_params.drug_buyer_name ? orderInfo.third_params.drug_buyer_name : '未填写用药人姓名'}}</el-col>
          <div v-if="orderInfo.ziti_status != 'APPROVE' && orderInfo.order_status != 'CANCEL' " >
            <div v-if="form.status == 'false'">
              <el-col :span="3" class="content-right"><h4>拒绝原因：</h4></el-col>
              <el-col :span="10">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入审核拒绝原因"
                  v-model="form.reject_reason">
                </el-input>
              </el-col>
            </div>
            <div v-else>
              <div v-if="orderInfo.ziti_status != 'APPROVE' && orderInfo.order_status != 'CANCEL' && form.receipt_type == 'ziti' && form.status == 'true' " >
                <el-col :span="3" class="content-right"><h4>自提门店：</h4></el-col>
                <el-col :span="10">
                  <el-select v-model="form.shop_id" filterable remote reserve-keyword placeholder="门店名称关键字" :remote-method="remoteMethod">
                    <el-option v-for="item in shopsList"
                               :key="item.wxShopId"
                               :label="item.storeName"
                               :value="item.wxShopId">
                      <span style="float: left">{{ item.storeName }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address}}</span>
                    </el-option>
                  </el-select>
                </el-col>
              </div>
              <!--
              <el-col :span="3" class="content-right"><h4>配送方式：</h4></el-col>
              <el-col :span="10">
                <el-radio v-model="form.receipt_type" label="ziti">门店自提</el-radio>
                <el-radio v-model="form.receipt_type" label="logistics">物流配送</el-radio>
              -->
              </el-col>
            </div>
          </div>
        </el-row>
        <el-row>
          <el-col :span="3" class="content-right"><h4>纸质处方单：</h4></el-col>
          <el-col :span="20">
            <span v-for="(item, index) in orderInfo.third_params.drug_list_image">
            <img class="item-image" :src="item.url" @click="imagedetail(item.url)"></img>
          </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11"> &nbsp; </el-col>
          <div v-if="orderInfo.ziti_status != 'APPROVE' && orderInfo.order_status != 'CANCEL' " >
            <el-col :span="10">
              <el-button type="primary" @click="process">提交审核</el-button>
            </el-col>
          </div>
        </el-row>
      </el-card>
      <el-dialog title="纸质处方单" :visible.sync="dialogVisible" width="80%" v-if="orderInfo.order_class == 'drug'">
        <img v-if="bigImageUrl" :src="bigImageUrl" style="width: 100%; max-width:100%"></img>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <el-card shadow="never" v-if="orderInfo.receipt_type || orderInfo.order_type == 'bargain'">
        <div slot="header" class="clearfix">
          <h3>物流信息</h3>
        </div>
        <el-row>
          <el-col :span="3" v-if="orderInfo.receipt_type == 'ziti'" class="content-right"><h4>自提地址：</h4></el-col>
          <el-col :span="12" v-if="orderInfo.receipt_type == 'ziti'">
            {{distributor.store_name}} <span class="frm-tips">{{distributor.store_address}}</span>
          </el-col>
        </el-row>
        <el-row>
          <div v-if="orderInfo.receiver_address">
            <el-col :span="3" class="content-right"><h4>收货人信息：</h4></el-col>
            <el-col :span="12">{{orderInfo.receiver_name}} , {{orderInfo.receiver_mobile}} , {{orderInfo.receiver_state}}{{orderInfo.receiver_city}}{{orderInfo.receiver_district}}{{orderInfo.receiver_address}} </el-col>
          </div>
        </el-row>
        <el-row v-if="orderInfo.delivery_status == 'DONE' && orderInfo.delivery_code">
          <el-col :span="3" class="content-right"><h4>快递公司：</h4></el-col>
          <el-col :span="3" v-if="orderInfo.order_status == 'WAIT_BUYER_CONFIRM'">
            <el-select v-model="orderInfo.delivery_corp" filterable placeholder="请选择快递公司，可搜索">
              <el-option
                v-for="item in dlycorps"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" v-else>
            {{dlycorpskn[orderInfo.delivery_corp]}}
            <el-button type="success" v-if="!orderInfo.delivery_corp == 'OTHER'" @click="deliveryDesc" size="mini">查看物流详情</el-button>
          </el-col>
          <el-col :span="3" class="content-right"><h4>快递单号：</h4></el-col>
          <el-col :span="5" v-if="orderInfo.order_status == 'WAIT_BUYER_CONFIRM'">
            <el-input v-model="orderInfo.delivery_code" :maxlength=20 placeholder="物流公司单号"></el-input>
          </el-col>
          <el-col :span="5" v-else>{{orderInfo.delivery_code}}</el-col>
          <el-col :span="3" class="content-right"><h4>发货时间：</h4></el-col>
          <el-col :span="5">{{orderInfo.delivery_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
        </el-row>
        <el-row>
          <el-col class="content-center">
            <el-button v-if="orderInfo.order_status == 'WAIT_BUYER_CONFIRM'" @click="updateDeliveryAction">修改物流信息</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-dialog title="物流详情" class="right-dialog" :visible.sync="dialog" :before-close="handleCancelLabelsDialog">
        <div class="block" v-if="this.activities.length > 0">
          <div class="radio">
            排序：
            <el-radio-group v-model="reverse">
              <el-radio :label="true">正序</el-radio>
              <el-radio :label="false">倒序</el-radio>
            </el-radio-group>
          </div>
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="activity.AcceptTime">
              {{activity.AcceptStation}}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div v-else class="block">暂无信息</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog = false">关  闭</el-button>
        </span>
      </el-dialog>
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3>备注：</h3>
        </div>
        <el-row>
          <div>
            客户备注： {{orderInfo.remark}}
          </div>
          <div v-if="orderInfo.receiver_address">
            管理员备注： {{orderInfo.admin_remarks}}
          </div>

        </el-row>
      </el-card>
      <div class="section-footer content-padded content-center with-border">
        <el-button @click="retrunClick">返回</el-button>
        <!-- <el-button @click="deleteNp(orderInfo.order_id)" type="danger">删除NP挂单</el-button> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" type="text/css">
  h3.title {
    padding: 20px;
    font-size: 18px;
    color: #ff5000;
  }
  .col-3 {
    width: 120px;
    margin-right: 10px;
  }
  .detail-info {
    margin: 0 10px;
  }
  .el-row {
    margin-bottom: 10px;
  }
  .item-image {
    max-width: 80px;
    margin: 0 auto;
  }
  img {
    max-width: 100px;
    margin: 0 auto;
  }
  .block{
    margin-left: 85px;
  }
  .radio{
    margin-bottom: 15px;
  }
</style>
<script>
  import { getOrderDetail, deleteNp,updateDelivery, processDrugOrders, getDeliveryDetail, getLogisticsList, getPayStatus } from '../../../../api/trade'
  import { getMember } from '../../../../api/member'
  import { getWxShopsList } from '@/api/shop'
  import hqbdlycorp_kname from '../../../../common/hqbdlycorp_kname.json'
  export default {
    data () {
      return {
        dialog: false,
        shopsList: [],
        dialogVisible: false,
        loading: false,
        order_id: '',
        orderInfo: {},
        distributor: {},
        distributor_arr:[],
        tradeInfo: {},
        tradeIf: {},
        cancelData: {},
        resource: '',
        order_menu_status:'',
        user_id: 0,
        memberInfo: {
          gradeInfo: {}
        },
        form: {
          status: 'true',
          receipt_type: 'ziti',
          reject_reason: '',
        },
        reverse: true,
        activities: [],
        dlycorpskn: hqbdlycorp_kname,
        bigImageUrl: '',
        dlycorps: [],
        deliveryForm: {
          delivery_type: 'batch',
          order_id: '',
          delivery_corp: '',
          delivery_code: '',
          sepInfo: {}
        },
      }
    },
    methods: {
      retrunClick () {
        this.$router.go(-1)
      },
      getPayStatus (tradeId) {
        getPayStatus({trade_id: tradeId}).then(response => {
          console.log(response.data.data)
          let res = response.data.data
          if (res.status === true) {
            if (res.data.orderStatus === '4') {
              this.$message({ type: 'success', message: res.data.orderStatusMsg})
              return
            } else {
              this.$message({ type: 'error', message: res.data.orderStatusMsg})
              return
            }
          }
          this.$message({ type: 'error', message: '接口请求失败，请稍后再试~'})
        })
      },
      handleCancelLabelsDialog() {
        this.dialog = false
      },
      deleteNp(orderId){
        deleteNp(orderId).then(response => {
          if(response.data.data.status === true){
            this.$message({ type: 'success', message: '删除成功'})
          }else{
            this.$message({ type: 'error', message: '删除失败'})
          }
        })
      },
      getMemberInfo (filter) {
        getMember(filter).then(response => {
          this.memberInfo = response.data.data
        })
      },
      deliveryDesc () {
        this.dialog = true
        let query = {
          delivery_corp: this.orderInfo.delivery_corp,
          delivery_code: this.orderInfo.delivery_code,
          delivery_corp_source: this.orderInfo.delivery_corp_source
        }
        getDeliveryDetail(query).then(response => {
          this.activities = response.data.data
        })
      },
      getMemberInfo (filter) {
        getMember(filter).then(response => {
          this.memberInfo = response.data.data
        })
      },
      process() {
        processDrugOrders(this.order_id, this.form).then(res => {
          this.$message({ type: 'success', message: '审核成功'})
          this.getDetail()
        })
      },
      remoteMethod (query) {
        getWxShopsList({page:1, pageSize: 100, name: query, distributor_id: this.orderInfo.distributor_id}).then(res => {
          this.shopsList = res.data.data.list
        })
      },
      getDetail () {
        this.loading = true
        getOrderDetail(this.order_id).then(response => {
          this.orderInfo = response.data.data.orderInfo
          this.tradeInfo = response.data.data.tradeInfo
          this.tradeIf = response.data.data.tradeIf
          this.distributor = response.data.data.distributor
          var dataArray = response.data.data.distributor;
          this.distributor_arr =  [];
          this.distributor_arr[0] =  dataArray;
          this.cancelData = response.data.data.cancelData
          this.loading = false
          this.getMemberInfo({'user_id': this.orderInfo.user_id})
        })
      },
      imagedetail (imgurl) {
        this.dialogVisible = true
        this.bigImageUrl = imgurl
      },
      getLogisticsList() {
        getLogisticsList().then(res => {
          this.dlycorps = res.data.data.list
        })
      },
      updateDeliveryAction () { // 修改物流信息
        if(this.orderInfo.delivery_corp) {
          this.deliveryForm.delivery_corp = this.orderInfo.delivery_corp
          this.deliveryForm.delivery_code = this.orderInfo.delivery_code
          this.deliveryForm.sepInfo = {}
        } else {
          this.deliveryForm.delivery_type = 'sep'
          this.deliveryForm.sepInfo = JSON.stringify(this.orderInfo.items)
          this.deliveryForm.delivery_corp = ''
          this.deliveryForm.delivery_code = ''
        }
        updateDelivery(this.order_id, this.deliveryForm).then( response => {
          var deliveryStatus = response.data.data.delivery_status
          if( deliveryStatus && deliveryStatus != 'PENDING') {
            this.$message.success('修改物流信息成功!')
            this.getDetail()
          } else {
            this.$message.error('修改物流信息失败!')
            return false
          }
        })
      },
    },
    mounted () {
      if (this.$route.query.orderId) {
        this.order_id = this.$route.query.orderId
      }
      if (this.$route.query.resource) {
        this.resource = this.$route.query.resource
      }
      if (this.$route.query.user_id) {
        this.user_id = this.$route.query.user_id
      }
      if (this.$route.query.order_menu_status) {
        this.order_menu_status = this.$route.query.order_menu_status
      }
      this.getDetail()
      this.getLogisticsList()
    }
  }
</script>
<style type="text/css">
  .sp_time{
    margin: 0 2rem;
  }
</style>



// WEBPACK FOOTER //
// detail.vue?7c01f296